/**
 * InviteUsers
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import InviteEmployees from './InviteEmployees.jsx';
import InviteParents from './InviteParents.jsx';
import InviteStudents from './InviteStudents.jsx';

function InviteUsers(props) {
  const { roleType } = useParams();

  switch (roleType) {
    case 'parent':
      return <InviteParents {...props} />;
    case 'employee':
      return <InviteEmployees {...props} />;
    case 'student':
      return <InviteStudents {...props} />;
    default:
  }
  return null;
}

export default InviteUsers;
